
<t-column :size="columnWidthClass">
  <template v-if="contentElement.is(ListViewContentElementLayoutType.Column)">
    <list-view-content-element-base
        v-for="element in contentElement.contentElementsArray"
        :key="element.id"
        :content-element="element"
        :entry="entry"
        :list-view="listView"
        :is-in-detail-view-edit-mode="isInDetailViewEditMode"
    ></list-view-content-element-base>
  </template>
  <component
    v-else-if="contentElement.is(ListViewContentElementLayoutType.ActionsColumn)"
    :is="contentElementActionsComponent()"
    :content-element="contentElement"
    @updateEntries="updateEntries"
    @updateConnectedRecords="decrementObjectModelEntriesTotalCount"
    :entry="entry"
    :is-in-detail-view-edit-mode="isInDetailViewEditMode"
    :list-view="listView"
    :user="user"
    :is-user-dashboard="isUserDashboard"
    >
  </component>
</t-column>
